import loadable from "@loadable/component";

export const UserList = loadable(() => import("./users-list/list"));

export const UserShow = loadable(() => import("./users-list/show"));

export const PartnerList = loadable(() => import("./partners-list/list"));

export const StaffsList = loadable(() => import("./staffs-list/list"));

export const AppUserShow = loadable(() => import("./app-user"), {
  resolveComponent: ({ AppUserShow }) => AppUserShow,
});

export const PropertyMangerShow = loadable(() => import("./property-manager"), {
  resolveComponent: ({ PropertyMangerShow }) => PropertyMangerShow,
});

export const UserUnlockRecords = loadable(() => import("./unlock-records"), {
  resolveComponent: ({ UserUnlockRecords }) => UserUnlockRecords,
});

export const CompaniesList = loadable(() => import("./companies-list"), {
  resolveComponent: ({ CompaniesList }) => CompaniesList,
});

export const CompanyMember = loadable(
  () => import("./companies-list/CompanyMember"),
  { resolveComponent: ({ CompanyMember }) => CompanyMember }
);

export const FetchRecord = loadable(() => import("./fetch-record/detail"), {
  resolveComponent: ({ FetchRecord }) => FetchRecord,
});
